export default {
  init() {
    //Ajout de la class active afin de changer le picto du burger
    $('.hamburger').each(function() {
      $(this).on('click', function() {
        $(this).toggleClass('is-active');
        $('.toggle').hide();
      });

      $(this).on('touchstart', function() {
        $(this).toggleClass('is-active');
        $('.toggle').hide();
      });

    });

    $('.hamburger').bigSlide({
      menu: '.MenuResponsive',
      speed: 300,
      side: 'right',
      menuWidth: '100%',
      easyClose: true,
      afterClose: function(){
        $('.hamburger').removeClass('is-active');
        $('.toggle').show();
      },
    });

    //Fermeture du menu lors d'un click sur une catégorie
    $('.MenuResponsive a').on('click', function() {
      $('.hamburger').trigger('click');
    });

    //Import de bootstrap toggle
    require('bootstrap4-toggle');

    //Récupération de toutes les classes dont on veut ajouter le dark mode
    let classes = $('body, .header-middle, .sub-menu , .menu-mdw-menu-container, .homepage-description, .MenuResponsive, .glossaire, .sommaire-fourth, .sommaire-words-links, .sommaire-words-letter, .footer, .notfound-404 h1, .contact-page, .tarifs')

    //Récupération du thème dans le localStorage
    let currentTheme = localStorage.getItem('currentTheme');

    //Vérification du thème préféré du visiteur
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (prefersDark || (currentTheme && currentTheme == 'dark')) {
      classes.addClass('dark-theme');
      localStorage.setItem('currentTheme', 'dark');
    } else {
      classes.removeClass('dark-theme');
      localStorage.setItem('currentTheme', 'light');
    }

    $('.mdw-switch-theme input').on('change', function() {
      let dad = $(this).parent();

      if ($(this).is(':checked')) {
        dad.addClass('mdw-switch-theme-checked');
        classes.addClass('dark-theme');
        localStorage.setItem('currentTheme', 'dark');
      } else {
        classes.removeClass('dark-theme');
        localStorage.setItem('currentTheme', 'light');
        dad.removeClass('mdw-switch-theme-checked');
      }
    });

    'use strict';

    let $filters = $('.filter [data-filter]'),
        $boxes = $('.client-cards [data-link]');

    $filters.on('click', function(e) {
      e.preventDefault();
      let $this = $(this);

      let $filterLink = $this.attr('data-filter');

      $filters.removeClass('active');

      if ($filterLink == 'all') {
        $boxes.fadeOut().promise().done(function() {
          $boxes.fadeIn();
          $this.addClass('active');
        });
      } else {
        $this.addClass('active');
        $boxes.fadeOut().promise().done(function() {
          $boxes.filter('[data-link = "' + $filterLink + '"]').fadeIn();
        });
      }
    });

    require ('magnific-popup');

    //Pop up pour téléphone
    $('#inline-popups').magnificPopup({
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = this.st.el.attr('data-effect');
        },
      },
      midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });

    $('.mdw-switch-status-customer input').on('change', function() {
      let dad = $(this).parent();

      if ($(this).is(':checked')) {
        dad.addClass('mdw-switch-status-customer-checked');
        $('.tarifs-entreprises').css('display', 'block');
        $('.tarifs-solo').css('display', 'none');
      } else {
        $('.tarifs-entreprises').css('display', 'none');
        $('.tarifs-solo').css('display', 'block');
        dad.removeClass('mdw-switch-status-customer-checked');
      }
    });

    $('.label-engagement').on('click', function() {
      $('.row-engagement').css('display', 'table-row');
      $('.row-sans-engagement').css('display', 'none');
      $('.row-engagement-paiement').css('display', 'none');
    });

    $('.label-sans-engagement').on('click', function() {
      $('.row-sans-engagement').css('display', 'table-row');
      $('.row-engagement').css('display', 'none');
      $('.row-engagement-paiement').css('display', 'none');
    });

    $('.label-engagement-paiement').on('click', function() {
      $('.row-engagement-paiement').css('display', 'table-row');
      $('.row-sans-engagement').css('display', 'none');
      $('.row-engagement').css('display', 'none');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js